import LoginPage from "../pages/login/LoginPage";
import ResetPasswordPage from "../pages/login/ResetPasswordPage";

export const auth_routes = [
    {
        path: "/",
        ele: <LoginPage />,
    },
    {
        path: "/login",
        ele: <LoginPage />,
    },
    {
        path: "/reset-password",
        ele: <ResetPasswordPage />,
    }
]